'use client';

import React, { useMemo } from 'react';

import { useDataProvider } from '@/components/flow/components/DataProvider/useDataProvider';
import { RxCard } from '@/components/product-selection/components/RxCards/components/rxCard';
import { useSelectedItemIds } from '@/components/product-selection/hooks/useSelectedItemIds';
import { DATA_KEYS } from '@/consts/dataKeys';
import { isDefined } from '@/utils/isDefined';

export const RxCards = () => {
  const { brand, rxCards, flags } = useDataProvider(DATA_KEYS.productSelection);
  const { isCardSelected, findCard } = useSelectedItemIds();

  const rxProductCards = useMemo(() => {
    const multiRxEnabled =
      (flags.agencyMultiRx && brand === 'agency') ||
      flags.multiRxRecommendations;

    if (multiRxEnabled) {
      return rxCards
        .map((cardIdentifier) => findCard(cardIdentifier))
        .filter(isDefined);
    } else {
      return [
        findCard(
          rxCards.find((cardId) => isCardSelected(cardId)) ?? rxCards[0],
        ),
      ].filter(isDefined);
    }
  }, [
    flags.agencyMultiRx,
    flags.multiRxRecommendations,
    brand,
    rxCards,
    findCard,
    isCardSelected,
  ]);

  if (!rxProductCards) {
    return null;
  }

  return rxProductCards.map((card) => <RxCard key={card.id} card={card} />);
};
